export default {
  CREATE_SCHEDULE: 'CREATE_SCHEDULE',
  UPDATE_SCHEDULE: 'UPDATE_SCHEDULE',
  CANCEL_SCHEDULE: 'CANCEL_SCHEDULE',
  CONFIRM_SCHEDULE: 'CONFIRM_SCHEDULE',
  GET_SCHEDULE: 'GET_SCHEDULE',
  RESET_SCHEDULE_CREATION_DATA: 'RESET_SCHEDULE_CREATION_DATA',
  HIDE_SCHEDULE_CREATION_SUCCESS_MESSAGE: 'HIDE_SCHEDULE_CREATION_SUCCESS_MESSAGE',
  TOGGLE_UPDATE_MODE: 'TOGGLE_UPDATE_MODE',
    ON_VALUE_CHANGE: 'ON_VALUE_CHANGE',
    RESCHEDULE_EVENT: 'RESCHEDULE_EVENT',
    GET_VIEW_ATTENDEE_DATA_FLAG: 'GET_VIEW_ATTENDEE_DATA_FLAG',
}